<div class="content-container">
    <h1>Udstyr</h1>
    <router-outlet></router-outlet>
    <!-- <app-equipment-overview></app-equipment-overview>
    <app-equipment-details></app-equipment-details> -->
</div>